import {RepairModel} from './repair.model';
import {EntrustedModel} from './entrusted.model';
import {AccidentModel} from './accident.model';
import {CompanyModel} from './company.model';

export class ComplaintModel {
	client_id?: string;
	plate: string;
	locator: LocatorType;
	activation: string;
	property: PropertyEntity;
	mod: ModType;
	notification: ClaimNotificationType;
	quote: boolean;
	repair: RepairModel;
	entrusted: EntrustedModel;
	data_accident: AccidentModel;
	from_company: CompanyModel;
	cc_poste?: string;

	constructor() {
		this.data_accident = new AccidentModel();
		this.entrusted = new EntrustedModel();
	}
}

export enum PropertyEntity {
	OUR = 'OUR',
	OTHERS = 'OTHERS'
}


export enum ModType {
	CAI = 'CAI', // denuncia con controparte con cai
	ARD = 'ARD', // denuncia sinistri senza controparte
	GEN = 'GEN', // denuncia con più controparti o controparte non veicolo
	LIT = 'LIT', // denuncia con controparte CAI lite
	NTW = 'NTW', // Modulo per denunce Inserite dal Network ( Kasko, Cristalli)
	CAL = 'CAL', // Modulo Light per denuncia Constatazione Amichevole di Incidente
	GEF = 'GEF', // Modulo Generico Furto
	CAM = 'CAM', // Modulo CAI Mobile ( Non implementato )
	ARM = 'ARM', // ARD Mobile
	GEM = 'GEM', // Modulo Generico Mobile ( Non implementato )
	NTM = 'NTM', // Modulo Network Mobile ( Non Implementato )
	CLM = 'CLM', // Modulo CAI LIGHT MOBILE
	GFM = 'GFM', // Modulo Generico Furto Mobile ( Non Implementato )
	CAI_LIGHT = 'CAI_LIGHT', // cai_light
	MODULO_MANAGER = 'MODULO_MANAGER', // Modulo manager (Modulo generico automatizzato tramite WebService per il Manager)
}

export enum LocatorType {
	MOVITRACK_LOJACK = 'Movitrack - Lojack',
	MOVITRACK = 'Movitrack',
	ARX_ON_DEMAND = 'ARX on demand',
	ARX_H24 = 'ARX H24',
	LOJACK = 'Lojack',
	ARX_VAN = 'ARX VAN',
	MOVITRACK_BLACK_BOX = 'Movitrack Black Box',
	OCTO_BASIC_FURTO_MOVITRACK = 'OCTO BASIC FURTO - Movitrack',
	OCTO_BASIC_FURTO_ARX_ON_DEMAND = 'OCTO BASIC FURTO - ARX o. d.',
	OCTO_BASIC_FURTO_ARX_H24 = 'OCTO BASIC FURTO - ARX H24',
	OCTO_BASIC_FURTO_LOJACK = 'OCTO BASIC FURTO - Lojack',
	OCTO_CRASH_LOJACK = 'OCTO CRASH - Lojack',
	OCTO_CRASH_MOVITRACK = 'OCTO CRASH - Movitrack',
	OCTO_FLEET_ECO_DRIVE_ARX_ON_DEMAND = 'OCTO FLEET&ECO DRIVE - ARX o. d.',
	OCTO_FLEET_ECO_DRIVE_ARX_H24 = 'OCTO FLEET&ECO DRIVE - ARX H24',
	OCTO_FLEET_ECO_DRIVE_MOVITRACK = 'OCTO FLEET&ECO DRIVE - Movitrack',
	OCTO_FLEET_ECO_DRIVE_PLUS_ARX_ON_DEMAND = 'OCTO FLEET&ECO DRIVE PLUS - ARX o. d.',
	OCTO_FLEET_ECO_DRIVE_PLUS_ARX_H24 = 'OCTO FLEET&ECO DRIVE PLUS - ARX H24',
	OCTO_FLEET_ECO_DRIVE_PLUS_MOVITRACK = 'OCTO FLEET&ECO DRIVE PLUS - Movitrack',
	OCTO_SUPEREASY_LOJACK = 'OCTO SUPEREASY - Lojack',
	OCTO_SUPEREASY_MOVITRACK = 'OCTO SUPEREASY - Movitrack',
	OCTO_SUPEREASY_ARX_ON_DEMAND = 'OCTO SUPEREASY - ARX o. d.',
	OCTO_SUPEREASY_ARX_H24 = 'OCTO SUPEREASY - ARX H24',
	OCTO_SICUREZZA_CRASH_MGMT_MOVITRACK = 'OCTO SICUREZZA&CRASH MGMT - Movitrack',
	OCTO_SICUREZZA_CRASH_MGMT_LOJACK = 'OCTO SICUREZZA&CRASH MGMT - Lojack',
	OCTO_SICUREZZA_CRASH_MGMT_ARX_ON_DEMAND = 'OCTO SICUREZZA&CRASH MGMT - ARX o. d.',
	OCTO_SICUREZZA_CRASH_MGMT_ARX_H24 = 'OCTO SICUREZZA&CRASH MGMT - ARX H24',
	OCTO_BASIC_FURTO = 'OCTO BASIC FURTO',
	OCTO_CRAH = 'OCTO CRASH',
	OCTO_SUPEREASY = 'OCTO SUPEREASY',
	OCTO_SICUREZZA_CRASH_MGMT = 'OCTO SICUREZZA&CRASH MGMT',
	TEXA_LOJACK = 'TEXA - Lojack',
	TEXA = 'TEXA'
}

export enum ClaimNotificationType {
	// CLAIM_COMPLAINT = 'CLAIM_COMPLAINT',
	CLAIM_COMPLAINT = 'Denuncia Sinistro Web',
	OPEN_FROM_MSA = 'OPEN_FROM_MSA',
	CLAIM_COMPLAINT_WEB = 'CLAIM_COMPLAINT_WEB',
	REQUESTED_FROM_COMPANY = 'REQUESTED_FROM_COMPANY',
	REQUESTED_DAMAGE_COUNTERPART = 'REQUESTED_DAMAGE_COUNTERPART',
	SUE = 'SUE',
	DECLARATION_IRREPARABILITY_VEHICLE = 'DECLARATION_IRREPARABILITY_VEHICLE',
	REAL_OFFER = 'REAL_OFFER',
	OTHER = 'OTHER',
	AUTHORITY_COMPLAINT = 'AUTHORITY_COMPLAINT',
	ROADSIDE_ASSISTANCE = 'ROADSIDE_ASSISTANCE',
	WINITY = 'WINITY',
	REPAIR = 'REPAIR',
	USE_STATUS_REPORT = 'USE_STATUS_REPORT',
	REQUESTED_DAMAGE_DEKRA = 'REQUESTED_DAMAGE_DEKRA',
	CLAIM_COMPLAINT_AND_SUE = 'CLAIM_COMPLAINT_AND_SUE',
	CLAIM_COMPLAINT_WEB_AND_SUE = 'CLAIM_COMPLAINT_WEB_AND_SUE',
	REQUESTED_DAMAGE_AND_SUE_COUNTERPART = 'REQUESTED_DAMAGE_AND_SUE_COUNTERPART',
	ROADSIDE_ASSISTANCE_AND_SUE = 'ROADSIDE_ASSISTANCE_AND_SUE',
	REQUESTED_DAMAGE_AND_SUE_DEKRA = 'REQUESTED_DAMAGE_AND_SUE_DEKRA',
	REQUESTED_DAMAGE_MSA = 'REQUESTED_DAMAGE_MSA',
	REQUESTED_DAMAGE_AND_SUE_MSA = 'REQUESTED_DAMAGE_AND_SUE_MSA',
	TELEPHONE_COMMUNICATION = 'TELEPHONE_COMMUNICATION',
	MISAPPROPRIATION = 'MISAPPROPRIATION',
	MISAPPROPRIATION_SUBRENTING = 'MISAPPROPRIATION_SUBRENTING',
	THEFT = 'THEFT',
	THEFT_FOR_ROBBERY = 'THEFT_FOR_ROBBERY',
	MYALD = 'MyALD'
}
